import { Component, ComponentRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { TransmittalMsgService } from 'src/app/Service/transmittal/transmittal.service';
import { ITransmittalDetailsModel, ITransmittalDocumentDetails, ITransmittalElementSLNoInputModel, ITransmittalMailDetails, ITransmittalMsgInputModel, ITransmittalSerialNoInputModel } from 'src/app/ViewModel/TransmittalModel';
import { formatDate } from '@angular/common';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { TransmittalTemplateComponent } from '../transmittal-template/transmittal-template.component';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { CommonTransmittalTemplateComponent } from '../templates/template_common/transmittal-template-common.component';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { Module } from 'src/app/Service/element-details.data.service';
import { WorkflowActionModel } from 'src/app/ViewModel/WorkflowActionModel';
import { RespondWorkflowListModel, WtfActionReassignToInputModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { IMsgDocumentAttachmentModel, IMsgElementInputModel } from 'src/app/ViewModel/CommunicationModel';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { TransmittalViewComponent } from '../transmittal-view/trasnsmittal-view.component';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { IMemebersViewModel } from 'src/app/ViewModel/MembersModel';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ILatestStageDetails } from 'src/app/ViewModel/ScheduleDocumentModel';
import { FileService } from 'src/app/Service/file/file.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';
import { WtfActionReassigntoDtnComponent } from '../../workflow/dialogs/wtf-action-reassignto-dtn/wtf-action-reassignto-dtn.component';

const componentMapper = {
  common: CommonTransmittalTemplateComponent,
  //hci:HCITransmittalTemplateComponent
};
@Component({
  selector: 'app-dtnrelease',
  templateUrl: './dtnrelease.component.html',
  styleUrls: ['./dtnrelease.component.css']
})
export class DTNReleaseComponent implements OnInit {
  memberId: number = 0;
  projectId!: number;
  groupId: number = 0;
  transmittalList: ITransmittalDetailsModel[] = [];
  public dtnList: any[] = [];
  public dtnReleaseForm!: FormGroup;
  transmittalForm!: FormGroup;
  public projectName!: string;
  componentRef!: ComponentRef<any>;
  private _transmittalData!: TransmittalTemplateComponent | null;
  public projectElements: IProjectElementsOutput[] = [];
  elementsConfig: FieldConfig[] = [];
  public numElements: Map<string, string> = new Map<string, string>();
  public numFormat!: string;
  public msgNo!: string;
  public messageNo!: string;
  public MessageId: number | any = null;
  public autoSerialNo!: string;
  public elementInp: IMsgElementInputModel[] = [];
  public isShowSerialNo: boolean = true;
  public canManualNo: boolean = false;
  public messageElements: any;
  public selectedList: any[] = [];
  public currentWorkflowDetails!: WorkflowTemplateDialogModel;
  public _wfDetails!: RespondWorkflowListModel;
  public workflowActions: WorkflowActionModel[] = [];
  public approveActionDetails: WorkflowActionModel[] = [];
  public gridData: any[] = [];
  public originalData: RespondWorkflowListModel[] = [];
  documentStatus?: number = 1;
  public datevalue = new Date(this.getDateFormat());
  public RespondOn: string = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
  public inputType: string = 'dtnRelease';
  public isDTNReleased: boolean = false;
  public semiNo: string = '0';
  public membersList: IMemebersViewModel[] = [];
  public mailReceiverDetails: any[] = [];
  public toMember: any[] = [];
  public ccMember: any[] = [];
  public fromMember: any[] = [];
  public delayReasonList: any[] = [];
  public internalReasonList: any[] = [];
  public externalReasonList: any[] = [];
  public today: Date = new Date();
  public ishowGrid: boolean = false;
  selectedDocCommentId: any;
  enableFilter!: boolean;
  dueOn: any;
  msgId!: number;
  isAllworkflow: boolean = false;
  LatestStageDetails: ILatestStageDetails[] = [];
  private docGrid!: GridComponent;
  public groupDetails: any;
  public docDetails: any;
  public receiverDetails: any;
  public transmittalNo: any = null;
  public clear: boolean = true;
  public currentProject: ProjectViewModel;
  private transmittalViewComponent!: TransmittalViewComponent;
  private attachmentsList!: IMsgDocumentAttachmentModel[];
  public docNextStepDetails: Observable<StandardOutputModel>[] = [];

  @ViewChild('docGrid') set Content(Content: GridComponent) {
    if (!!Content) {
      this.docGrid = Content;
    }
  }
  // @ViewChild(TransmittalTemplateDirective) transmittalHost: TransmittalTemplateDirective;
  @ViewChild("docSetForm") dynamicForm!: DynamicFormComponent;
  @ViewChild('transmittalViewComponent') set content(content: TransmittalViewComponent) {
    if (!!content) { // initially setter gets called with undefined
      this.transmittalViewComponent = content;
    }
  }

  constructor(
    private _transmittalService: TransmittalMsgService,
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DTNReleaseComponent>,
    private notificationService: NotificationService,
    private _projService: ProjectInfoService,
    private _transmittalMsgService: TransmittalMsgService,
    private communicationService: CommunicationService,
    public workflowTemplateService: WorkflowTemplateService,
    public memberService: ExternalMemberService,
    private transmittalService: TransmittalService,
    private _fileService: FileService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.currentProject = this.commonService.getCurrentProjectDetails();
    this.projectName = this.currentProject.projectCode + ' - ' + this.currentProject.projectDescription;
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.currentProject.projectId;
    this.groupId = this.commonService.getLoggedInUserGroupId();

    this.numFormat = 'Auto';

    let getProjectMembers = this.getProjectMembers();
    let getCanManualNo = this.callMemberRoleandFeature();

    forkJoin([getProjectMembers, getCanManualNo]).subscribe((res: any[]) => {
      this.membersList = res[0];

      this.canManualNo = res[1].some((data: { feature_Desc: string; }) => data.feature_Desc == 'Manual No');

      this.transmittalList = this.data.transmittalList;
      let dtnList1 = this.transmittalList.map((element => {
        return { "message_Id": element.message_Id, "message_Number": element.message_Number };
      }));
      dtnList1 = dtnList1.reduce((accumalator: any, current) => {
        if (
          !accumalator.some(
            (item: any) => item.message_Id === current.message_Id && item.message_Number === current.message_Number
          )
        ) {
          accumalator.push(current);
        }
        return accumalator;
      }, []);
      this.dtnList = dtnList1.filter(x => x.message_Number == x.message_Id.toString());

      this.transmittalNo = this.data.selectedCommentSheetNo;
      this.originalData = this.data.selectedList;
    });

    this.dtnReleaseForm = this.formBuilder.group({
      formDTNList: new FormControl('', Validators.required),
    });

    this.transmittalForm = this._formBuilder.group({
      txtMsgSerialNo: new FormControl({ value: '', disabled: true }),
      txtSerialNo: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[0-9]*$")]),
    });

    this.delayReasonList = [{ id: 1, commentType: "Internal Reason" }, { id: 2, commentType: "External Reason" }, { id: 3, commentType: "Other" }]
    this.internalReasonList = [{ id: 1, IntrcommentType: "Multi disciplinary coordination" }, { id: 2, IntrcommentType: "Non availability of staff" },
    { id: 3, IntrcommentType: "Delay in interface input" }, { id: 4, IntrcommentType: "Delay in Internal review" }, { id: 5, IntrcommentType: "Delayed approval from ECD" },
    { id: 6, IntrcommentType: "Hardware Issues – Printer / Plotter" }, { id: 7, IntrcommentType: "Wrongly entered schedule date" },
    { id: 8, IntrcommentType: "Drawing released through manual transmittal" }, { id: 9, IntrcommentType: "Drawing revised during workflow in progress" }]
    this.externalReasonList = [{ id: 1, ExtrcommentType: "Delay in Client Input" }, { id: 2, ExtrcommentType: "Delay in Vendor Input" },
    { id: 3, ExtrcommentType: "Delayed approval from Client / Consultant" }, { id: 4, ExtrcommentType: "Delayed receipt of vendor clearance / approval" }]
  }

  getProjectMembers() {
    return this.memberService.GetMembersListAgainstProject({ project_Id: this.projectId });
  }

  callMemberRoleandFeature() {
    return this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId);
  }

  loadGrid() {
    return this._transmittalService.GetTransmittalList({ project_id: this.projectId });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  async onDTNValueChange(event: { value: number | any; }, formControlName: string) {
    if (event.value == -2) {
      this.clear = false

      return;
    }
    if (this.clear == false)
      this.clear = true;
    this.msgId = event.value;
    if (formControlName == 'formDTNList') {
      if (event.value > 0 && event.value != null) {
        this.MessageId = event.value;
        this.groupDetails = [];
        this.docDetails = [];
        this.receiverDetails = [];

        let fileInput_Communication = {
          projectId: this.data.projectId,
          messageId: this.data.selectedCommentSheetNo
        }

        let groupData = this._transmittalService.GetTransmittalGroupMemberDetails(this.MessageId);
        let receiverData = this._transmittalService.GetTransmittalReceiverDetails(this.MessageId);
        let workflowData = this.workflowTemplateService.getWorkflowTemplate(this.data.workflowId);
        let getTransmittalFiles = this._fileService.GetFiles({ libraryNumber: 4, value: JSON.stringify(fileInput_Communication) });

        forkJoin([groupData, receiverData, workflowData, getTransmittalFiles]).subscribe(res => {
          this.groupDetails = res[0];
          this.docDetails = this.data.transmittalDocumentDetails;
          this.receiverDetails = res[1];
          this.currentWorkflowDetails = res[2];
          this.attachmentsList = res[3];
          let filteredDTN: ITransmittalDetailsModel = this.transmittalList.filter(x => x.message_Id == event.value)[0];
          this.pushTransmittalTemplateModel(filteredDTN);
          this.getDelayReasonDocument();
        });
      }
    }
  }

  pushTransmittalTemplateModel(data: ITransmittalDetailsModel) {
    if (!!this.receiverDetails && !!this.docDetails && !!this.groupDetails) {
      let transDocDetails: ITransmittalDocumentDetails[] = [];
      if (!!this.docDetails && !!this.docDetails.transmittalDocumentDetails) {
        transDocDetails = this.docDetails.transmittalDocumentDetails;
      }
      let to = this.receiverDetails.transmittalToDetails[0].member_Id;
      let toWithAddress;
      if (to) {
        let toMember: any[] = this.membersList.filter(x => x.member_Id == to)
        if (toMember && toMember.length > 0 && toMember[0].address) {
          toWithAddress = toMember[0].member_Name + '<br>' + toMember[0].address;
        }
        else if (toMember && toMember.length > 0 && toMember[0].member_Name) {
          toWithAddress = toMember[0].member_Name
        }
      }
      else {
        toWithAddress = this.receiverDetails.transmittalToDetails.map((x: { member_Name: any; }) => x.member_Name).join(',')
      }
      let transmittalTemplate: TransmittalTemplateComponent = {
        templateName: 'common',
        projName: this.projectName,
        edrcRef: data.message_Number,
        cusRef: data.cust_Ref_No,
        docDetails: transDocDetails,
        distributionDetails: this.groupDetails,
        subject: data.message_Subject,
        attention: this.receiverDetails.transmittalToDetails.map((x: { member_Name: any; }) => x.member_Name).join(','),
        to: toWithAddress,
        date: formatDate(data.created_On, 'dd-MMM-yyyy', 'en-US'),
        message_No: data.message_Number,
        message_id: data.message_Id,
        cc: this.receiverDetails.transmittalCcDetails.map((x: { member_Name: any; }) => x.member_Name).join(','),
        From: this.receiverDetails.transmittalFromDetails.map((x: { member_Name: any; }) => x.member_Name).join(','),
        workflowId: null,
        fileDetails: this.attachmentsList && this.attachmentsList.length > 0 ? this.attachmentsList : []
      }
      this.mailReceiverDetails.push(this.receiverDetails);
      this._transmittalData = null;
      this._transmittalData = transmittalTemplate;
      this.FillselectedList();
      this._transmittalData.workflowId = this.selectedList[0].workflowId;
    }
  }



  setIsShow() {
    let styles = {
      'display': this.gridData.length > 0 ? 'block' : 'none',
    };
    return styles;
  }

  getDelayReasonDocument() {
    this.transmittalService.GetDocDelayReason(this.msgId).subscribe((data: any[]) => {
      data.forEach((Val, i) => {
        Val["selectedDocCommentId"] = null;
        this.dueOn = Val.scheduledOn;
        let doDate = formatDate(this.dueOn, 'yyyy-MM-dd', 'en-US');
        let today = formatDate(this.today, "yyyy-MM-dd", 'en-US');
        if (today > doDate) {
          Val["isDelayed"] = true;
        }
        else {
          Val["isDelayed"] = false;
        }
      })
      this.gridData = data.filter(value => value.isDelayed == true);
      if (this.gridData.length > 0) {
        this.ishowGrid = true;
        this.gridData.forEach((x, i) => {
          let obj: any = {};
          this.docGrid.editRow(i);
          if (!!x.delay_Reason) {
            x.selectedDocCommentId = 3;
            x.comments = x.delay_Reason;
            x["selectedCmdType"] = x.delay_Reason;
            obj["text"] = x.delay_Reason;
            this.onselectedValueChange(obj, x);
          } else if (!!x.external_Reason) {
            let setSelectValue = x.external_Reason.split('-')
            let setSelectedId = this.externalReasonList.filter(value => value.ExtrcommentType == setSelectValue[1])[0];
            if (setSelectedId) {
              x.setExtrselectedId = setSelectedId.id;
              x["selectedCmdType"] = x.external_Reason;
              x.selectedDocCommentId = 2;
              obj["text"] = x.external_Reason;
            }
            this.onselectedValueChange(obj, x);
          } else if (!!x.internal_Reason) {
            let setSelectValue = x.internal_Reason.split('-')
            let setSelectedId = this.internalReasonList.filter(value => value.IntrcommentType == setSelectValue[1])[0];
            if (setSelectedId) {
              x.setIntrselectedId = setSelectedId.id;
              x["selectedCmdType"] = x.internal_Reason;
              x.selectedDocCommentId = 1;
              obj["text"] = x.internal_Reason;
            }
            this.onselectedValueChange(obj, x);
          }
        })
      }
    })
  }

  async GenerateDTN() {
    this.transmittalForm.get('txtMsgSerialNo')?.valueChanges.subscribe(x => {
      this.generateMessageNo();
    });
    this.transmittalForm.get('txtSerialNo')?.valueChanges.subscribe(x => {
      this.generateMessageNo();
    })
    if (this.MessageId > 0) {
      this.messageElements = await this.communicationService.getMessageElementsById(this.MessageId).toPromise();
      this.elementInp = this.messageElements.map((x: { deId: any; deDescription: any; dedId: any; dedDescription: any; dedShortDescription: any; }) => {
        return {
          deId: x.deId,
          deDescription: x.deDescription,
          dedId: x.dedId,
          dedDescription: x.dedDescription,
          dedShortDescription: x.dedShortDescription,
          sortBy: 1
        }
      });
      this.getDynamicForm();
    }
    else {
      this.notificationService.showPopup("Please Select Transmittal No", "Warning");
    }
  }

  onselectedValueChange(event: { value?: any; text?: any; }, dataItem: any) {
    if (event.value != "-2") {
      dataItem["Doccomment_typeRequired"] = null;
      dataItem["otherCommentsRequired"] = null;
      if (event.text == "Internal Reason") {
        dataItem.selectedDocCommentId = 1;
        dataItem["Doccomment_typeRequired"] = true;
      } else if (event.text == "External Reason") {
        dataItem.selectedDocCommentId = 2;
        dataItem["Doccomment_typeRequired"] = false;
      } else if (event.text == "Other") {
        dataItem.selectedDocCommentId = 3;
        dataItem["otherCommentsRequired"] = true;
      }
      dataItem["selectedCom"] = event.text;
    } else {
      dataItem["delayReason"] = null;
      dataItem["Doccomment_typeRequired"] = null;
      dataItem["otherCommentsRequired"] = null;
      dataItem["selectedCmdType"] = null;
      dataItem["internalReason"] = null;
      dataItem["externalReason"] = null;
    }
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  onIntrValueChange(event: { value: string; text: string; }, rowData: any) {
    if (event.value != "-2") {
      rowData["selectedCmdType"] = "InternalReason - " + event.text;
    } else {
      rowData["selectedCmdType"] = null;
    }
  }

  onExtrValueChange(event: { value: string; text: string; }, rowData: any) {
    if (event.value != "-2") {
      rowData["selectedCmdType"] = "ExternalReason - " + event.text;
    } else {
      rowData["selectedCmdType"] = null;
    }
  }

  onValueChange(event: { target: { value: any; }; }, dataItem: any) {
    dataItem["selectedCmdType"] = event.target.value;
  }

  getDynamicForm() {
    this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Transmittal, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.elementsConfig = res.map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.Transmittal,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
          }
          if (x.isMandatory) {
            field.validations = [
              {
                name: "required",
                validator: Validators.required,
                message: field.name + " is Required"
              }
            ]
          }
          if (x.isNumbering) {
            this.numElements.set(x.elementDescription, '');
          }
          let dedValue = this.messageElements.find((el: { deId: number; }) => el.deId == x.elementId);
          if (!!dedValue) {
            field.value = new BehaviorSubject(dedValue.dedId);
          }
          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();
        let resForm: FormGroup = this.dynamicForm.value;
        //Numbering elements array
        let numberingElements: string[] = Array.from(this.numElements.keys());
        numberingElements.forEach(element => {
          resForm.get(element)?.valueChanges.subscribe(x => {
            if (!!x && (this.numFormat == 'Auto' || this.numFormat == 'Semi')) {
              if (this.numElements.has(element)) {
                if (!!x)
                  this.numElements.set(element, x.dedShortDescription);
                else
                  this.numElements.set(element, '');
              }
              this.GetMessageSerialNo();
            }
          });
        });
        this.onCascadingAutocomplete_Change();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach((data: any) => {
      if (!!data.child_de_id) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe(x => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;
          if (_field.length > 0 && !!parentControlSelectedValue) {
            this._projService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.Transmittal,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                _field[0].values = res;
              }
              else {
                _field[0].values = [];

              }
            }, err => { });
          }
          else {
            _field[0].values = [];

          }
        })
      }
    })
  }

  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  private generateMessageNo() {
    let serialNo: any = this.getFormValue('txtSerialNo', this.transmittalForm);
    this.messageNo = this.getFormValue('txtMsgSerialNo', this.transmittalForm);
    if (!!serialNo) {
      this.messageNo = this.messageNo + "-" + this.getFormValue('txtSerialNo', this.transmittalForm);
    }
    let filteredDTN: ITransmittalDetailsModel = this.transmittalList.filter(x => x.message_Id == this.MessageId)[0];
    filteredDTN.message_Number = this.messageNo;
    this.pushTransmittalTemplateModel(filteredDTN);
  }
  GetMessageSerialNo() {
    //Coin the Document number based on the element values selection changes
    let elementValues: string[] = Array.from(this.numElements.values());
    let selectedElementValues: string[] = elementValues.filter(val => val != '');
    this.msgNo = elementValues.filter(val => val != '').join('-');
    this.transmittalForm.get('txtMsgSerialNo')?.setValue(this.msgNo);
    //Ensure all the mandatory numering elements selected
    if (elementValues.length > 0 && elementValues.length == selectedElementValues.length) {
      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInp = this.projectElements.filter(x => x.isNumbering && !!resForm.get(x.elementDescription)?.value).map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        if (!!selectedValue) {
          let result: ITransmittalElementSLNoInputModel = {
            deId: x.elementId,
            dedId: selectedValue.dedId,
            deDescription: x.elementDescription,
            dedDescription: selectedValue.dedDescription,
            dedShortDescription: selectedValue.dedShortDescription,
            sortBy: +selectedValue.sortBy
          }
          return result;
        }
      });
      let inputModel: ITransmittalSerialNoInputModel = { projectId: this.commonService.getProjectId(), groupId: this.groupId, moduleId: Module.Transmittal, elementDetails: this.elementInp };
      this._transmittalMsgService.getTransmittalSerialNo(inputModel).subscribe((result: StandardOutputModel) => {
        //Set manipulated value from the parent component(W.r.t other documents elements selection while bulk upload)
        this.transmittalForm.get('txtSerialNo')?.setValue(String(result.result).padStart(5, '0'));
      });
    }
  }

  onNumFormatChange(value: string) {
    this.numFormat = value;
    this.messageNo = '';
    this.isShowSerialNo = this.numFormat == 'Auto' || this.numFormat == 'Semi';

    if (this.numFormat == 'Auto') {
      this.transmittalForm.get('txtMsgSerialNo')?.setValue('');
      this.transmittalForm.get('txtSerialNo')?.setValue('');
      this.transmittalForm.get('txtMsgSerialNo')?.disable();
      this.transmittalForm.get('txtSerialNo')?.disable();

    } else if (this.numFormat == 'Semi') {
      this.transmittalForm.get('txtMsgSerialNo')?.setValue('');
      this.transmittalForm.get('txtSerialNo')?.setValue('');
      this.transmittalForm.get('txtSerialNo')?.enable();
      this.transmittalForm.get('txtMsgSerialNo')?.disable();

    }
    else if (this.numFormat == 'Manual') {
      this.transmittalForm.get('txtMsgSerialNo')?.setValue('');
      this.transmittalForm.get('txtSerialNo')?.setValue('');
      this.transmittalForm.get('txtMsgSerialNo')?.enable();
      this.transmittalForm.get('txtSerialNo')?.disable();
    }

    let filteredDTN: ITransmittalDetailsModel = this.transmittalList.filter(x => x.message_Id == this.MessageId)[0];
    filteredDTN.message_Number = '';
    this.pushTransmittalTemplateModel(filteredDTN);
  }

  async dtnRelease() {
    if (this.gridData.length > 0) {
      let validate = this.gridData.some(data => !data.selectedCom || !data.selectedCmdType);
      if (validate) {
        this.notificationService.showToast("Please fill the delayreason to proceed further", "Warning");
        return;
      }
    }
    this.selectedList = [];
    this.data.documentList.forEach(x => {
      let obj = {
        documentId: x[0].documentId,
        revisionNo: x[0].revisionNo,
        workflowId: x[0].workflowId,
        assignedType: x[0].assignedType,
        taskSerialNumber: x[0].taskSerialNumber,
        subWorkflow: x[0].subWorkflow,
        taskId: x[0].taskId,
        currentTaskId: x[0].currentTaskId,
        CurrentStatusId: x[0].status_Id
      }
      this.selectedList.push(obj);
    });

    let is_Send_Mail: boolean = false;
    let semiNo: string = '0';
    let msgNo: string = this.getFormValue("txtMsgSerialNo", this.transmittalForm);
    if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
      semiNo = this.getFormValue("txtSerialNo", this.transmittalForm);
      semiNo = semiNo.toString().replace(/\D|^0+/g, "");
      this.semiNo = semiNo;
      msgNo = msgNo + '-' + this.getFormValue("txtSerialNo", this.transmittalForm);
    }
    let transmittalMsgInputDetails: ITransmittalMsgInputModel = {
      inputType: this.inputType,
      project_Id: this.projectId,
      message_Id: this.MessageId,
      message_Number: msgNo,
      message_Serial_Number: +semiNo,
      discipline: 0,
      parent_Message_Id: 0,
      message_Type: 141,
      has_Attachments: true,
      is_Confidential: true,
      message_Category: 3,
      message_Subject: "",
      message_Body: "",
      response_Type: 0,
      respond_On: this.RespondOn,
      issue_Reason: 10,
      sent_On: is_Send_Mail ? this.datevalue : null,
      is_Mail_Sent: is_Send_Mail,
      is_Active: true,
      userId: this.memberId
    };
    this.selectedList.forEach((data, i) => {
      this.gridData.forEach((value) => {
        if (data.documentId == value.doc_Id) {
          if (value.selectedDocCommentId == 3) {
            data["delay_Reason"] = value.selectedCmdType;
            data["external_Reason"] = "";
            data["internal_Reason"] = "";
            data["selectedDocCommentId"] = value.selectedDocCommentId;
          } else if (value.selectedDocCommentId == 2) {
            data["external_Reason"] = value.selectedCmdType;
            data["delay_Reason"] = "";
            data["internal_Reason"] = "";
            data["selectedDocCommentId"] = value.selectedDocCommentId;
          } else if (value.selectedDocCommentId == 1) {
            data["internal_Reason"] = value.selectedCmdType;
            data["selectedDocCommentId"] = value.selectedDocCommentId;
            data["external_Reason"] = "";
            data["delay_Reason"] = "";
          }
        }
      })
    })

    this._transmittalMsgService.InsertUpdateTransmittalDetails(transmittalMsgInputDetails).toPromise().then((x: StandardOutputModel) => {
      if (x.successCode == 200 || x.successCode == 205) {
        this.isDTNReleased = true;
        if (this.selectedList.length > 0) {
          //Get the current workflow step actions & ensure that any of the action is invovled in supersede operation
          let currentTask = this.currentWorkflowDetails.workflowStatus.filter(item => item.sub_Workflow == this.selectedList[0].subWorkflow && item.workflow_Status == this.selectedList[0].taskId)[0];
          this.workflowActions = this.currentWorkflowDetails.workflowAction.filter(x => x.task_Id == currentTask.task_Id);
          this.approveActionDetails = this.workflowActions.filter(item => item.action_Description == 'Approve');

          for (let i = 0; i < this.selectedList.length; i++) {
            let _respondWorkflowDetails: any = { "projectId": 0, "groupId": 0, respondWorkflowDetails: [], createdBy: 0, stageDetails: this.LatestStageDetails };
            let obj: any = {};
            obj["documentId"] = this.selectedList[i].documentId;
            obj["revisionNumber"] = this.selectedList[i].revisionNo;
            obj["workflowId"] = this.selectedList[i].workflowId;
            obj["TaskId"] = this.selectedList[i].currentTaskId;
            obj["assignType"] = this.selectedList[i].assignedType;
            obj["memberId"] = this.memberId;
            obj["actionPerformed"] = 99;  // DTN Release -- only Approve action possible
            obj["completedBy"] = this.memberId;
            obj["statusId"] = this.selectedList[i].CurrentStatusId;
            obj["completedOn"] = null;
            obj["comments"] = " ";
            obj["delayReason"] = this.selectedList[i].selectedDocCommentId == 3 ? this.selectedList[i].delay_Reason : null;
            obj["internalReason"] = this.selectedList[i].selectedDocCommentId == 1 ? this.selectedList[i].internal_Reason : null;
            obj["externalReason"] = this.selectedList[i].selectedDocCommentId == 2 ? this.selectedList[i].external_Reason : null;
            obj["isFileAvailable"] = true;
            obj["taskSlNo"] = this.selectedList[i].taskSerialNumber;
            obj["commentSheetNo"] = msgNo;
            _respondWorkflowDetails.projectId = this.projectId;
            _respondWorkflowDetails.groupId = this.groupId;
            _respondWorkflowDetails.createdBy = this.memberId;
            _respondWorkflowDetails.respondWorkflowDetails.push(obj);

            this.assignNextStep(_respondWorkflowDetails, this.approveActionDetails[0], this.selectedList[i]);
          }
          if (this.docNextStepDetails && this.docNextStepDetails.length > 0) {
            let workflowIdList = this.data.documentList.map(x => x[0].workflowId);
            let workflowTemplateDetails: WorkflowTemplateDialogModel[] = [];
            if (workflowIdList.length == 1) {
              workflowTemplateDetails.push(this.currentWorkflowDetails);
            }
            else if (workflowIdList.length > 1) {
              workflowTemplateDetails.push(this.currentWorkflowDetails);
              workflowIdList = workflowIdList.filter(x => x != this.currentWorkflowDetails.workflow_Id);
              if (workflowIdList && workflowIdList.length > 0) {
                let uniqueWorkflowId = workflowIdList.filter((x, ind) => workflowIdList.indexOf(x) === ind).join(',');
                if (uniqueWorkflowId && uniqueWorkflowId.length > 0)
                  this.workflowTemplateService.getWorkflowTemplateDetails(uniqueWorkflowId).subscribe((res: WorkflowTemplateDialogModel[]) => {
                    res.forEach(x => {
                      workflowTemplateDetails.push(x);
                    })
                  })
              }
            }

            forkJoin(this.docNextStepDetails).subscribe(res => {
              let successList: WtfActionReassignToInputModel[] = [];
              this.data.documentList.forEach((x, index) => {
                if (!!res[index]) {
                  let val = res[index];
                  if (val.successCode == 200) {
                    let isNextStepAva = Boolean(JSON.parse(val.result.toString().split(',')[0]));
                    let _nextStepId = parseInt(JSON.parse(val.result.toString().split(',')[1]));
                    let worklfowtemplate = workflowTemplateDetails && workflowTemplateDetails.filter(temp => temp.workflow_Id == x[0].workflowId).length > 0 ? workflowTemplateDetails.filter(temp => temp.workflow_Id == x[0].workflowId)[0] : null;
                    let isforReassigment = worklfowtemplate.isForReAssignment
                    let stepDetail: WorkflowTemplateStatusInputModel = worklfowtemplate.workflowStatus.filter(x => x.step_Id == _nextStepId)[0];
                    let isSetpForReassignment = stepDetail ? stepDetail.is_Step_For_Reassignment : false;
                    if (isNextStepAva && isforReassigment && isSetpForReassignment && !!stepDetail) {
                      let nextStepAssignedToRoles: WorkflowAssignedToModel[] = worklfowtemplate.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id > 0);
                      let nextStepAssignedToMember: WorkflowAssignedToModel[] = worklfowtemplate.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id == 0 && r.member_Id > 0);
                      if ((!!nextStepAssignedToRoles && nextStepAssignedToRoles.length > 0) || (!!nextStepAssignedToMember && nextStepAssignedToMember.length > 0)) {
                        x[0]['nextStepDetail'] = stepDetail;
                        x[0]['nextStepAssignedToRoles'] = nextStepAssignedToRoles && nextStepAssignedToRoles.length > 0 ? nextStepAssignedToRoles : null;
                        x[0]['nextStepAssignedToMember'] = nextStepAssignedToMember && nextStepAssignedToMember.length > 0 ? nextStepAssignedToMember : null;
                        successList.push(x[0]);
                      }
                    }
                  }
                }
              })
              if (successList && successList.length > 0) {
                let dialogRef1 = this.dialog.open(WtfActionReassigntoDtnComponent, {
                  panelClass: 'mat-dialog-primary',
                  data: { successList: successList, workflowTemplateDetails: workflowTemplateDetails },
                  width: '50%'
                })
              }
            })
          }
        }
      }
      else {
        this.notificationService.showPopup(x.successMessage, "Warning");
      }
    });
  }

  public assignNextStep(_respondWorkflowDetails: any, action: WorkflowActionModel, doclist: RespondWorkflowListModel) {
    if (this.currentProject.icDescription == "BF - Buildings & Factories")
      _respondWorkflowDetails.To_member_Id = parseInt(this.receiverDetails.transmittalToDetails[0].member_Id);

    // this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails).toPromise().then(data => {
    //   if (!!data) {
    //     this.gridData = [];
    //     this.notificationService.showToast(data["successMessage"], "Success");
    //   }
    //   else {
    //     this.notificationService.showToast("Failed to Move Next Step", "Error");
    //   }
    // });
    this.docNextStepDetails.push(this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails));
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  async sendMail(is_Send_Mail: boolean) {
    if (is_Send_Mail) {
      let toMemberIds = this.mailReceiverDetails[0].transmittalToDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let ccMemberIds = this.mailReceiverDetails[0].transmittalCcDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let fromMemberIds = this.mailReceiverDetails[0].transmittalFromDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let toMemberIdList: any[] = this.getMailIDList(toMemberIds);
      let ccMemberIdList: any[] = this.getMailIDList(ccMemberIds);
      let fromMemberIdList: any[] = this.getMailIDList(fromMemberIds);
      this.toMember = this.membersList.filter(f => toMemberIdList.some(item => item.memberId === f.member_Id));
      this.ccMember = this.membersList.filter(f => ccMemberIdList.some(item => item.memberId === f.member_Id));
      this.fromMember = this.membersList.filter(f => fromMemberIdList.some(item => item.memberId === f.member_Id));
      let semiNo: string = '0';
      let msgNo: string = this.getFormValue("txtMsgSerialNo", this.transmittalForm);
      if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
        semiNo = this.getFormValue("txtSerialNo", this.transmittalForm);
        semiNo = semiNo.replace(/\D|^0+/g, "");
        this.semiNo = semiNo;
        msgNo = msgNo + '-' + this.getFormValue("txtSerialNo", this.transmittalForm);
      }
      let transmittalMsgInputDetails: ITransmittalMsgInputModel = {
        inputType: 'sendTransmittalMail',
        project_Id: this.projectId,
        message_Id: this.MessageId,
        message_Number: this.messageNo,
        message_Serial_Number: +this.semiNo,
        discipline: 0,
        parent_Message_Id: 0,
        message_Type: 141,
        has_Attachments: true,
        is_Confidential: true,
        message_Category: 3,
        message_Subject: "",
        message_Body: "",
        response_Type: 0,
        respond_On: this.RespondOn,
        issue_Reason: 10,
        sent_On: is_Send_Mail ? this.datevalue : null,
        is_Mail_Sent: is_Send_Mail,
        is_Active: true,
        userId: this.memberId
      };
      await this._transmittalMsgService.InsertUpdateTransmittalDetails(transmittalMsgInputDetails).subscribe(async (x: StandardOutputModel) => {
        if (x.successCode == 200 || x.successCode == 205) {
          let sTo: string = this.toMember.map(x => x.eMail_Id).join(',');
          let sCC: string = this.ccMember.map(x => x.eMail_Id).join(',');
          let sFrom: string = this.fromMember.map(x => x.eMail_Id).join(',');
          if (!!sTo && !!sFrom && !!sCC) {
            let filteredDTN: ITransmittalDetailsModel = this.transmittalList.filter(x => x.message_Id == this.MessageId)[0];
            let mailDetails: ITransmittalMailDetails = {
              from_List: sFrom,
              to_List: sTo,
              cc_List: sCC,
              project_Code: this.commonService.getProjectCode(),
              discipline: this.isNull(filteredDTN.discipline_Description),
              mail_Body: this.transmittalViewComponent.getHtmlContent(),
              mail_Subject: this._transmittalData ? this._transmittalData.subject : "",
              message_Id: this.MessageId
            }
            await this._transmittalMsgService.SendTransmittalMail(mailDetails).subscribe((res: StandardOutputModel) => {
              if (res.successCode == 200 || res.successCode == 205) {
                this.notificationService.showPopup("Transmittal Sent successfully", "Success");
                this.closeDialog();
              }
              else {
                this.notificationService.showPopup(res.successMessage, "Warning");
              }
            });
          }
          else {
            this.notificationService.showPopup("Please give valid mail to user", "Warning");
          }
        }
        else {
          this.notificationService.showPopup(x.successMessage, "Warning");
        }
      });
    }
    else {
      this.closeDialog();
    }
  }

  getMailIDList(input: any) {
    let globArr: { memberId: number; }[] = [];
    let arr = input;
    let result = arr.split(',');
    result.forEach(function (obj: string) {
      let memberObj = { memberId: parseInt(obj, 10) }
      globArr.push(memberObj);
    });
    return globArr;
  }

  isNull(data: string) {
    return data != null ? data : '';
  }

  async GenerateDTNManual() {
    if (this.MessageId > 0) {
      if (this.numFormat == 'Manual') {
        this.messageNo = this.getFormValue('txtMsgSerialNo', this.transmittalForm);
        let filteredDTN: ITransmittalDetailsModel = this.transmittalList.filter(x => x.message_Id == this.MessageId)[0];
        filteredDTN.message_Number = this.messageNo;
        this.pushTransmittalTemplateModel(filteredDTN);
      }
      else {
        this.notificationService.showPopup("Please Select Transmittal No", "Warning");
      }
    }
  }

  FillselectedList() {
    this.selectedList = [];
    this._transmittalData.docDetails.forEach(x => {
      let filteredDoc: RespondWorkflowListModel[] = this.originalData.filter(y => y.documentId == x.doc_Id && y.revisionNo == x.revision_No);
      if (filteredDoc.length > 0)
        this.selectedList.push(filteredDoc[0]);
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}

